<template>
	<b-form @submit.prevent>
		<b-row>
			<b-col v-if="!hideStatus" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Status" label-for="status" label-cols-lg="4">
					<b-form-select
						name="status"
						:class="{ highlight: filters.status !== null }"
			            @change="highlight"
						v-model="filters.status"
						:disabled="disabled"
						:options="statuses"
						value-field="value"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col v-if="!hideOpen" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Status" label-for="inprocess" label-cols-lg="4">
					<b-form-select
						name="inprocess"
						v-model="inprocess"
						:disabled="false"
						class="open"
					>
				      <option value="InProcess">In Process</option>
					</b-form-select>
				</b-form-group>
            </b-col>
			<b-col v-if="!hideClosed" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Status" label-for="closed" label-cols-lg="4">
					<b-form-select
						name="closed"
						v-model="closed"
						:disabled="false"
						class="inprocess"
						
					>
					    <option value="Closed">Closed</option>
					</b-form-select>
				</b-form-group>
            </b-col>
			<b-col v-if="!hideUTC" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Status" label-for="utc" label-cols-lg="4">
					<b-form-select
						name="utc"
						v-model="filters.unable_to_complete"
						:disabled="false"
						class="inprocess"	
					>
					    <option value="1">Unable To Complete</option>
					</b-form-select>
				</b-form-group>
            </b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Type" label-for="request_type" label-cols-lg="4">
					<b-form-select
						name="request_type"
						:class="{ highlight: filters.request_type !== null }"
			            @change="highlight"
						v-model="filters.request_type"
						:disabled="disabled"
						:options="types"
						value-field="value"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Priority" label-for="priority" label-cols-lg="4">
					<b-form-select
						name="priority"
						:class="{ highlight: filters.priority !== null }"
			            @change="highlight"
						v-model="filters.priority"
						v-bind="{ disabled }"
						:options="priorityOptions"
					/>
				</b-form-group>
			</b-col>
			<b-col v-if="!hideAssignedTo" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Assign To" label-for="assigned_to" label-cols-lg="4">
					<b-form-select
						name="assigned_to"
						:class="{ highlight: filters.assigned_to !== null }"
			            @change="highlight"
						v-model="filters.assigned_to"
						:disabled="disabled"
						:options="activeUsers"
						value-field="id"
						text-field="full_name"
					>
						<template #first>
							<option :value="null">(All)</option>
							<option :value="false">(Unassigned)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col v-if="!hideUnassinged" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Assigned To" label-for="unassigned" label-cols-lg="4">
					<b-form-select
						name="unassigned"
						v-model="filters.assigned_to"
						:disabled="false"
						class="inprocess"
					>
						
						<option :value="false">(Unassigned)</option>
				
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Insurance Provider" label-for="insurance_provider_id" label-cols-lg="4">
					<b-form-select
						name="insurance_provider_id"
						:class="{ highlight: filters.insurance_provider_id !== null}"
			            @change="highlight"
						v-model="filters.insurance_provider_id"
						:disabled="disabled"
						:options="insuranceProviders"
						value-field="id"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Agency" label-for="agency_id" label-cols-lg="4">
					<b-form-select
						name="agency_id"
						:class="{ highlight: filters.agency_id !== null }"
			            @change="highlight"
						v-model="filters.agency_id"
						:disabled="disabled"
						:options="agencies"
						value-field="id"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Request ID" label-for="id">
					<search-input 
						name="id"
						v-model="filters.id"
						:key="filters.id" 
						:class="{ highlight: filters.id && filters.id.trim() !== '' }"
						@input="(value) => filters.id = value !== '' ? value : null"
						:disabled="disabled"
						
					/>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Facility" label-for="facility_name">
					<search-input
					name="facility_name"
					v-model="filters.facility_name"
					:key="filters.facility_name"  
					:class="{ highlight: filters.facility_name && filters.facility_name.trim() !== '' }"
					@input="(value) => filters.facility_name = value !== '' ? value : null"
					:disabled="disabled"
					/>
				</b-form-group>
		    </b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Sent To" label-for="sent_to" label-cols-lg="4">
					<b-form-select
						name="sent_to"
						:class="{ highlight: filters.submittedTo !== null }"
						@change="highlight"
						v-model="filters.submittedTo"
						:disabled="disabled"
						:options="activeUsers"
						value-field="id"
						text-field="full_name"
					>
						<template #first>
							<option :value="null">(All)</option>
							<option :value="'Facility'">Facility</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>

		</b-row>
	</b-form>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";

export default {
	name: "CaseRequestFilters",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					status: null,
					request_type: null,
					assigned_to: null,
					insurance_provider_id: null,
					agency_id: null,
					priority: null,
					id: null,
					facility_name: null,
					submittedTo : null,
				};
			},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hideAssignedTo: {
			type: Boolean,
			default: false,
		},
		hideStatus: {
			type: Boolean,
			default: false,
		},
		hideUnassinged: {
			type: Boolean,
			default: true,
		},
		hideOpen: {
			type: Boolean,
			default: true,
		},
		hideClosed: {
			type: Boolean,
			default: true,
		},
		hideUTC: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		filters: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		...mapGetters({
			activeUsers: "users/active",
			statuses: "caseRequests/statuses",
			senttoOptions: "caseRequests/sentto",
			types: "caseRequests/types",
			agencies: "agencies/active",
			insuranceProviders: "insuranceProviders/active",
		}),
	},
	data() {
		return {
			utc: 1,
			inprocess:"InProcess",
			completed:"Completed",
			unassigned: "Null",
			priorityOptions: [
				{ text: "(All)", value: null },
				{ text: "Yes", value: true },
				{ text: "No", value: false },
			],
			isUsed: {
				status: false,
				request_type: false,
				assigned_to: false,
				insurance_provider_id: false,
				agency_id: false,
				priority: false,
				id: false,
				facility_name: false,
				sent_to : false,
			},
		};
	},
	methods: {
		highlight(field) {
         this.$set(this.isUsed, field, this.filters[field] !== null && this.filters[field] !== "");
        },
    },
};
</script>
<style>
.highlight {
  border: 2px solid #007bff; /* Example: blue border */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Optional: blue shadow */
}
.inprocess {
  border: 2px solid #007bff; /* Example: blue border */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Optional: blue shadow */
  color:black;
}
</style>  